import { useState } from "react";
import { Builder } from './Builder';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface ConditionalLogicTabsProps {
    open: boolean;
    title: string;
    visibleCondition?: Condition;
    requiredCondition?: Condition;
    onChangeVisible: (c?: Condition) => void;
    onChangeRequired: (c?: Condition) => void;
    onClose: () => void;
    questions: Record<string, PolicyFormQuestion>;
}

export const ConditionalBuilder = ({
    open,
    title,
    visibleCondition,
    requiredCondition,
    onChangeVisible,
    onChangeRequired,
    onClose,
    questions
}: ConditionalLogicTabsProps) => {
    const [tab, setTab] = useState<'visible' | 'required'>('visible');

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className="max-w-2xl ">
                <DialogHeader>
                    <DialogTitle className="text-lg font-semibold text-primary-dark">{title}</DialogTitle>
                </DialogHeader>

                <Tabs value={tab} onValueChange={(v) => setTab(v as "visible" | "required")}>
                    <TabsList>
                        <TabsTrigger value="visible">Visible</TabsTrigger>
                        <TabsTrigger value="required">Required</TabsTrigger>
                    </TabsList>

                    <TabsContent value="visible">
                        <Builder
                            condition={visibleCondition}
                            onChange={onChangeVisible}
                            questions={questions}
                        />
                    </TabsContent>

                    <TabsContent value="required">
                        <Builder
                            condition={requiredCondition}
                            onChange={onChangeRequired}
                            questions={questions}
                        />
                    </TabsContent>
                </Tabs>
            </DialogContent>
        </Dialog>
    );
};